/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React, {useEffect, useState} from 'react';
import AdminUsersView from "../../views/admin/AdminUsersView";
import {getFrom, patchTo} from "../../data/api";
import {CircularProgress} from "@mui/material";

function UsersRoute(props) {
    const [users, setUsers] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [filterSubmitted, setFilterSubmitted] = useState(false)
    const [filter, setFilter] = useState({page: 0, req_limit: 25})
    const [usersPerRequest, setUsersPerRequest] = useState(25)

    const updateFilter = (which, data) => {
        const f = {...filter}
        if(data === "") return;
        switch (which){
            case "name": f.name = data; break;
            case "email": f.email = data; break;
            case "role": f.role = data; break;
            case "page": f.page = data; break;
            case "req_limit": f.req_limit = usersPerRequest; break;
            default: return;
        }
        setFilter({...f});
    }

    const updateFilterModel = (e) => {
        e.items.forEach((item)=>{
            updateFilter(item.columnField, item.value)
        })
    }

    const submitFilter = () => {
        setFilterSubmitted(true)
        loadUsers(filter)
    }

    const editUserData = (e) => {
        const data = {}
        data[e.field] = e.value
        patchTo('/users/'+e.id, data)
            .then((res)=>{
            })
            .catch((e)=>{
                console.error(e)
            })
    }

    const loadUsers = (f = null) => {
        getFrom('/users', f)
            .then((res)=>{
                //got users
                setUsers(res.data);
                setFilterSubmitted(false);
                setIsLoading(false)
            })
            .catch((e)=>{
                //Bad reguest
                setFilterSubmitted(false);
                setIsLoading(false)
            })
    }

    useEffect(()=>{
        submitFilter()
    }, [filter])

    useEffect(()=>{
        loadUsers()
    },[])
    if (isLoading){
        return <CircularProgress/>
    }else {
        return (
            <AdminUsersView users={users.data}
                            loadUsers={loadUsers}
                            updateFilterRole={(e)=>{updateFilter('role', e.target.value)}}
                            updateFilterName={(e)=>{updateFilter('name', e.target.value)}}
                            updateFilterEmail={(e)=>{updateFilter('email', e.target.value)}}
                            updateFilterPage={(pageNumber)=>{updateFilter('page', pageNumber)}}
                            filter={filter}
                            submitFilter={submitFilter}
                            isFilterSubmitted={filterSubmitted}
                            numberOfRecords={users.count}
                            editData={editUserData}
                            updateFilterModel={updateFilterModel}
            />
        );
    }
}

export default UsersRoute;